import axios from "axios";
import store from "../app/store";
import { showLoader, hideLoader } from "../app/loaderSlice";// Base URL for all API calls
//const PROD_BASE = "https://gorexamapi.gores.in/api/";
// const BASE_URL = "https://localhost:44304/api/";
//const BASE_URL = "http://200.141.12.87/api/"
const PROD_BASE = "https://goreeduhub.cloud/api/";
// const BASE_URL = "https://localhost:7048/api/";


const getAuthToken = () =>
  sessionStorage.getItem("token") ||
  localStorage.getItem("token") ||
  sessionStorage.getItem("jwtToken") ||
  localStorage.getItem("jwtToken") ||
  "";


// Create an Axios instance
const apiClient = axios.create({
  baseURL: PROD_BASE,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// Add JWT Token Authorization Interceptor
// Request Interceptor
apiClient.interceptors.request.use((config) => {
  store.dispatch(showLoader()); // Show Loader before each API request

  const token = getAuthToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => {
    store.dispatch(hideLoader()); // Hide Loader after successful API response
    return response;
  },
  (error) => {
    store.dispatch(hideLoader()); // Hide Loader if an error occurs
    return Promise.reject(error);
  }
);

// Common API Methods
const apiService = {
  get: (url, params = {}, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.get(url, {
      params,
      headers:
        authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
    });
  },

  download: (url, data = {}, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.post(url, data, {
      responseType: "blob", // This is crucial for file downloads
      headers:
        authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
    });
  },

  post: (url, data = {}, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.post(url, data, {
      headers:
        authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
    });
  },

  put: (url, data = {}, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.put(url, data, {
      headers:
        authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
    });
  },

  delete: (url, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.delete(url, {
      headers:
        authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {},
    });
  },

  postFormData: (url, formData, authRequired = true) => {
    const token = getAuthToken();

    return apiClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",

        ...(authRequired && token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {}),
      },
    });
  },
};

export default apiService;
